@if (isControlsEnabled) {
<div
  role="group"
  [attr.aria-label]="'Call HUD' | translate"
  class="room-info fx-row fx-align-center fx-justify-space-between"
  [class.room-info-agent]="isRecorderVisible"
  [class.room-info-whisper]="isWhisper"
  [class.hidden]="!isTopBarVisible"
  data-tid="conference/room-info"
>
  @if (isRecorderVisible) {
  <app-recorder
    [options]="recorderOptions"
    [interaction]="interaction"
    (started)="recStarted($event)"
    (stopped)="recStopped($event)"
  ></app-recorder>
  }
  <app-timer></app-timer>
  @if (!isWhisper) {
  <app-network-indicator [endpoint]="endpoint"></app-network-indicator>
  } @if (isInteractionDataVisible) {
  <av-tooltip position="bottom">
    <av-icon name="info-round" size="sm" mode="light"></av-icon>
    <ng-container tooltipMessage>
      <div>
        <b translate>Interaction details</b>
      </div>
      <table class="interaction-details">
        <tr>
          <td><small class="text-muted">ID</small></td>
          <td>
            <small data-tid="conference/interaction-id">{{
              interactionID
            }}</small>
          </td>
        </tr>
        @if (!!agentDisplayName()) {
        <tr>
          <td><small class="text-muted" translate>Agent</small></td>
          <td>
            <small data-tid="conference/interaction-agent-name">
              {{ agentDisplayName() }}
            </small>
          </td>
        </tr>
        }
      </table>
      <!-- <div class="fx-row fx-gap-10"></div>
          <div class="fx-row fx-gap-10"></div> -->
    </ng-container>
  </av-tooltip>
  } @if (isWhisper) {
  <av-tooltip position="bottom">
    <ng-container tooltipMessage>
      {{ "Monitoring call" | translate }}
    </ng-container>
    <av-icon name="binoculars" size="sm" mode="light"></av-icon>
  </av-tooltip>
  }
</div>
} @if (isRequestingMedia()) {
<av-card
  #mediaRequestCardRef
  class="device-help device-help-middle device-help-middle-offset device-help-allow"
>
  <av-card-body type="container">
    <div class="text-center">
      <div class="device-help-allow-image device-help-allow-image-bkg"></div>
      <h1 translate [innerHTML]="'Click Allow' | translate"></h1>
      <p translate>
        You can still turn your camera and microphone off in the call.
      </p>
    </div>
  </av-card-body>
</av-card>
} @if (isDeviceHelpVisible()) {
<av-card
  class="device-help device-help-middle device-help-allow"
  [attr.aria-live]="'polite'"
  [attr.aria-label]="deviceErrorAriaLabel | translate"
  avTrapFocus
  role="alert"
  tabindex="0"
  #mediaErrorCardRef
>
  <av-card-header [autofocus]="false" (close)="dismissHelp()"></av-card-header>
  <av-card-body>
    <div class="text-center">
      @if (notAllowedError()) { @if (isMobile) {
      <img
        src="/modules/shared/assets/images/mobile-browser-media.png"
        alt="{{ 'Check device settings' | translate }}"
      />
      } @if (!isMobile) {
      <img
        src="/modules/shared/assets/images/desktop-browser-media.png"
        alt="{{ 'Check device settings' | translate }}"
      />
      }
      <h3 aria-hidden="true" translate>access blocked</h3>
      <p translate>enable access</p>
      } @if (notFoundError()) {
      <h3 aria-hidden="true" translate>Devices not available</h3>
      <p translate>
        You need at least a camera or a microphone to join the call.
      </p>
      } @if (streamError()) { @if (isMobile) {
      <img
        src="/modules/shared/assets/images/mobile-browser-media.png"
        alt="{{ 'Check device settings' | translate }}"
      />
      } @if (!isMobile) {
      <img
        src="/modules/shared/assets/images/desktop-browser-media.png"
        alt="{{ 'Check device settings' | translate }}"
      />
      }
      <h3 aria-hidden="true" translate>Your devices are not responding</h3>
      <p translate>
        Please check your camera and/or microphone device and try again.
      </p>
      } @if (isWebViewError() || isMediaRequestTimeoutError()) { @if
      (isMobileAndroid) {
      <img
        src="/modules/shared/assets/images/mobile-browser-media-webview-android.png"
        alt="{{ 'Check device settings' | translate }}"
      />
      } @if (isMobileIOS) {
      <img
        src="/modules/shared/assets/images/mobile-browser-media-webview-ios.png"
        alt="{{ 'Check device settings' | translate }}"
      />
      } @if (isWebViewError()) {
      <h3 aria-hidden="true" translate>Limited access to media devices</h3>
      } @if (isMediaRequestTimeoutError()) {
      <h3 aria-hidden="true" translate>
        Accessing your camera and microphone is taking longer than usual
      </h3>
      }
      <p translate>
        Please open this page in a compatible web browser from a nearby menu.
      </p>
      <button
        color="accent"
        size="block"
        [raised]="true"
        avButton
        (click)="copyToClipboard(url)"
        class="fx-row fx-align-center fx-justify-center fx-gap-10"
      >
        <av-icon name="copy-document" size="xs"></av-icon>
        <span translate>Copy room link</span>
      </button>
      <small class="text-muted" translate>
        Or, copy the link above and open it in a compatible web browser.
      </small>
      }
      <!-- <ng-container *ngIf="isMediaRequestTimeoutError()">
        <h3 translate>
          Accessing your camera and microphone is taking longer than usual
        </h3>
        <p translate>
          Please open this page in a standard web browser from a nearby menu.
        </p>
      </ng-container> -->
    </div>
  </av-card-body>
</av-card>
} @if (hasNoParticipants && !pipActive()) {
<div
  class="text-muted text-center fx-column fx-gap-10 container-pad-md container-empty"
>
  @if (isCustomer || isWhisper) { @if (!isAgentPresent) {
  <span translate>Waiting for agent...</span>
  } @if (isAgentPresent) {
  <span translate>Agent online</span>
  } } @if (isAgent) { @if (!isCustomerPresent) {
  <span translate>Waiting for customer...</span>
  } @if (isCustomerPresent) {
  <span translate>Customer online</span>
  } }
</div>
}

@if (pipActive()) {
<app-pip-placeholder></app-pip-placeholder>
}

<div #container class="tile-container" [ngClass]="containerCssClass">
  @if (!isDeviceSetupOpen) { @for (stream of streams; track
  trackByMediaIdFn($index, stream)) {
  <app-tile
    #tiles
    [attr.id]="
      stream.originator.endpoint +
      '-' +
      (stream.primary ? 'primary' : 'secondary')
    "
    [stream]="stream"
    [interaction]="interaction"
    (ready)="tileReady($event)"
    (destroyed)="tileDestroyed($event)"
    [avFileDragDrop]="{ enabled: isFileTransferAvailable(stream) }"
    [avFileAllowedExtensions]="allowedFileTypes"
    (filesDropped)="filesDropped($event, stream.originator)"
  >
    @if (isLaserVisible) {
    <app-point-area [stream]="stream"> </app-point-area>
    }
    <div
      [class.tile-actions-over]="isTileActionOnTop(stream)"
      [class.tile-actions-ar]="isLaserActive(stream)"
      class="tile-actions fx-row fx-align-start fx-justify-start"
    >
      <app-tile-controls
        [interaction]="interaction"
        [stream]="stream"
      ></app-tile-controls>
      <app-tile-info
        [interaction]="interaction"
        [stream]="stream"
      ></app-tile-info>
    </div>
  </app-tile>
  } @if (isCobrowseActive && !isRating) {
  <app-cobrowse-session
    (ready)="tileReady($event)"
    (destroyed)="tileDestroyed($event)"
    [interaction]="interaction"
  >
  </app-cobrowse-session>
  } @if ((snapshotStream || isSnapshotActive) && !isRating) {
  <app-snapshot-session
    [stream]="snapshotStream"
    [interaction]="interaction"
    [review]="isReviewingSnapshots"
    (ready)="tileReady($event)"
    (destroyed)="tileDestroyed($event)"
  >
  </app-snapshot-session>
  } }
</div>

<!-- [class.hidden]="!isControlsVisible" -->
@if (isStreamControlsEnabled) {
<app-stream-controls
  #streamControlsRef
  [interaction]="interaction"
  [mediaControlsEnabled]="!isRequestingMedia()"
  [@slideIn]="true"
  (leave)="leaveConference()"
  (terminate)="terminateConference()"
  (exit)="exitConference()"
  (mediaError)="mediaError($event)"
>
</app-stream-controls>
} @if (streamControls()?.isRingLightOn()) {
<app-ring-light
  [intensity]="streamControls()?.ringLightIntensity()"
  [warmth]="streamControls()?.ringLightWarmth()"
></app-ring-light>
} @if (isCaptionsEnabled && isControlsEnabled) {
<div
  class="captions-container"
  [class.captions-container-no-media-controls]="!isControlsVisible"
  [class.captions-container-mobile]="isMobile"
  [@toast]="true"
>
  @if (isCaptionsAvailable) {
  <app-captions-control
    class="captions-control"
    [conferenceId]="conferenceId"
    [istream]="localAudioVideoStream"
    [stream]="mystream"
  ></app-captions-control>
  }
  <app-captions class="captions"></app-captions>
</div>
} @if (isDeviceSetupAvailable()) {
<div
  class="device-setup-container"
  [class.device-setup-container-taldesk]="isTalkdeskApp"
  [class.device-setup-container-mobile]="isMobile"
  [@fadeInOut]="true"
>
  <app-device-setup
    [conversationType]="interactionType"
    (canceled)="cancel()"
    (accepted)="acceptConstraints()"
  >
  </app-device-setup>
</div>
} @if (!isRating && !isReviewingSnapshots) {
<app-hold
  #holdRef
  [interaction]="interaction"
  [videoReady]="!!localTile"
  [enabled]="isOnHold"
></app-hold>
}

<app-rating [interaction]="interaction"></app-rating>

@if (isDeviceSetup) {
<app-stream-play-button #streamPlayRef></app-stream-play-button>
<app-audio-interruption-overlay></app-audio-interruption-overlay>
}

<av-ai-assistant></av-ai-assistant>

<!-- cannot check if speaker can be used without actually using it on an audio track -->
<audio src="/assets/sounds/notif_test.mp3" #testSound></audio>
<audio src="/assets/sounds/notif_in.mp3" #notificationIn></audio>
<audio src="/assets/sounds/notif_out.mp3" #notificationOut></audio>
